import { SubmissionStage } from '../statuses';
// Stage order for progression
export const SUBMISSION_STAGE_ORDER = [
    SubmissionStage.Complaint,
    SubmissionStage.DemandLetter,
    SubmissionStage.Lawsuit,
];
// Stage configuration with metadata
export const STAGE_CONFIG = {
    [SubmissionStage.Complaint]: {
        order: 1,
        title: 'submission.stages.complaint.title',
        description: 'submission.stages.complaint.description',
        icon: 'DocumentTextIcon',
        color: 'blue',
        estimatedDays: 7,
        responseDeadlineDays: 14,
        requiresCertifiedMail: false,
        allowsEmailOnly: true,
    },
    [SubmissionStage.DemandLetter]: {
        order: 2,
        title: 'submission.stages.demand_letter.title',
        description: 'submission.stages.demand_letter.description',
        icon: 'ExclamationTriangleIcon',
        color: 'yellow',
        estimatedDays: 10,
        responseDeadlineDays: 30,
        requiresCertifiedMail: true,
        allowsEmailOnly: false,
    },
    [SubmissionStage.Lawsuit]: {
        order: 3,
        title: 'submission.stages.lawsuit.title',
        description: 'submission.stages.lawsuit.description',
        icon: 'ScaleIcon',
        color: 'red',
        estimatedDays: 30,
        responseDeadlineDays: 45,
        requiresCertifiedMail: true,
        allowsEmailOnly: false,
    },
};
// Helper functions
export const getNextStage = (currentStage) => {
    const currentIndex = SUBMISSION_STAGE_ORDER.indexOf(currentStage);
    if (currentIndex === -1 || currentIndex === SUBMISSION_STAGE_ORDER.length - 1) {
        return null;
    }
    return SUBMISSION_STAGE_ORDER[currentIndex + 1];
};
export const getPreviousStage = (currentStage) => {
    const currentIndex = SUBMISSION_STAGE_ORDER.indexOf(currentStage);
    if (currentIndex <= 0) {
        return null;
    }
    return SUBMISSION_STAGE_ORDER[currentIndex - 1];
};
export const getStageProgress = (currentStage) => {
    const currentIndex = SUBMISSION_STAGE_ORDER.indexOf(currentStage);
    if (currentIndex === -1)
        return 0;
    return ((currentIndex + 1) / SUBMISSION_STAGE_ORDER.length) * 100;
};
export const isValidStageProgression = (fromStage, toStage) => {
    const fromIndex = SUBMISSION_STAGE_ORDER.indexOf(fromStage);
    const toIndex = SUBMISSION_STAGE_ORDER.indexOf(toStage);
    return fromIndex !== -1 && toIndex !== -1 && toIndex > fromIndex;
};
export const getStagesFromTo = (startStage, includeNext = false) => {
    const startIndex = SUBMISSION_STAGE_ORDER.indexOf(startStage);
    if (startIndex === -1)
        return [startStage];
    if (!includeNext) {
        return [startStage];
    }
    return SUBMISSION_STAGE_ORDER.slice(startIndex);
};
// Response deadline calculation
export const calculateResponseDeadline = (stage, sentDate = new Date()) => {
    const config = STAGE_CONFIG[stage];
    const deadline = new Date(sentDate);
    deadline.setDate(deadline.getDate() + config.responseDeadlineDays);
    return deadline;
};
